<div class="schema-list">
  <div class="schema-filter-container">
    <div class="filter-row">
      <mat-form-field subscriptSizing="dynamic" class="search-field">
        <mat-label>Search records by name</mat-label>
        <input matInput (keyup)="onSearchKeyup($event)" placeholder="e.g. Aflac" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="status-filter-field">
        <mat-label>Filter by status</mat-label>
        <mat-select [value]="statusFilter" (selectionChange)="onStatusFilterChange($event.value)">
          <mat-option value="all">All</mat-option>
          @for (status of availableStatuses; track status) {
            <mat-option [value]="status">
              {{ getRecordStatusConfig(status).label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (customFilter of getAllCustomFilters(); track customFilter) {
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-filter-field"
          >
          <mat-label>Filter by {{ customFilter.key }}</mat-label>
          <mat-select
            [value]="getCustomFilterValue(customFilter)"
            (selectionChange)="onCustomFilterChange(customFilter, $event.value)"
            >
            <mat-option value="all">All</mat-option>
            @for (value of getAvailableCustomFilterValues(customFilter); track value) {
              <mat-option
                [value]="value"
                >
                {{ value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <button
        mat-stroked-button
        class="clear-filters-button"
        (click)="clearAllFilters()"
        [disabled]="
          !searchFilter && (!statusFilter || statusFilter === 'all') && !hasActiveCustomFilters()
        "
        >
        <mat-icon>clear</mat-icon>
        Clear Filters
      </button>
    </div>
  </div>
  @if (getSelectableRecordCount() > 0) {
    <div class="schema-selection-summary">
      <div class="selection-info">
        <span class="primary-count">
          {{ getSelectedRecordCount() }} of {{ getSelectableRecordCount() }} selectable records
          selected
        </span>
        @if (hasHiddenSelections()) {
          <span class="hidden-selections-warning">
            <mat-icon class="warning-icon">visibility_off</mat-icon>
            {{ getHiddenSelectionsCount() }} selected records hidden by current filters
          </span>
        }
      </div>
    </div>
  }
  @for (schema of schemas; track schema) {
    <div class="schema-list-item">
      <div class="schema-list-item-header" (click)="toggleSchemaExpansion(schema)">
        <div class="schema-header-main">
          <div class="checkbox-container" (click)="$event.stopPropagation()">
            @if (getFilteredSelectableRecords(schema).length > 0) {
              <mat-checkbox
                [checked]="isSchemaChecked(schema)"
                [indeterminate]="isSchemaIndeterminate(schema)"
                [disabled]="getFilteredSelectableRecords(schema).length === 0"
                (change)="toggleSchemaSelection(schema)"
                class="schema-checkbox"
                >
              </mat-checkbox>
            }
            @if (getFilteredSelectableRecords(schema).length === 0) {
              <div
                class="custom-checkbox-disabled"
              ></div>
            }
          </div>
          <p class="schema-title">
            {{ schema.schemaName }}
          </p>
        </div>
        <div class="expand-toggle-icon">
          <mat-icon>{{ schema.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
      </div>
      @if (schema.isExpanded) {
        <div class="schema-records-wrapper">
          <div class="schema-record-list">
            @if (getFilteredRecords(schema).length === 0 && (!!searchFilter || !!statusFilter)) {
              <div
                class="no-records-message"
                >
                <span>No records found matching your filters in this schema</span>
              </div>
            }
            @for (record of getFilteredRecords(schema); track record) {
              <div class="record-list-item">
                <div class="record-list-item-header" (click)="toggleRecordExpansion(record)">
                  <div class="record-header-main">
                    <div class="checkbox-container" (click)="$event.stopPropagation()">
                      @if (isRecordSelectable(record)) {
                        <mat-checkbox
                          [checked]="record.isSelected"
                          [disabled]="!isRecordSelectable(record)"
                          (change)="toggleRecordSelection(record, schema)"
                          class="record-checkbox"
                          >
                        </mat-checkbox>
                      }
                      @if (!isRecordSelectable(record)) {
                        <div class="custom-checkbox-disabled"></div>
                      }
                    </div>
                    <p class="record-title">
                      {{ record.label }}
                    </p>
                    <div class="record-status-tags">
                      <mat-chip-set>
                        @for (status of getRecordStatuses(record); track status) {
                          <mat-chip
                            [ngClass]="getRecordStatusConfig(status).css"
                            >
                            {{ getRecordStatusConfig(status).label }}
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </div>
                  </div>
                  <div class="expand-toggle-icon">
                    <mat-icon>{{ record.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </div>
                </div>
                @if (record.isExpanded) {
                  <div class="record-comparison-wrapper">
                    <div class="record-environments">
                      <div class="record-environment-column">
                        <app-json-diff [diffLines]="getQADiffLines(record)" title="QA"></app-json-diff>
                      </div>
                      <div class="record-environment-column">
                        <app-json-diff
                          [diffLines]="getProdDiffLines(record)"
                          title="Production"
                        ></app-json-diff>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
